export function getQuestions(studentAnswer) {
  if (!studentAnswer) return [];
  return Object.values(studentAnswer.questions);
}
